<template>
  <v-app>
  </v-app>
</template>

<script>
import Vue from 'vue';
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import ddoWaiting from '@/components/ddoWaiting.vue'

let initial_row = {}

export default {
   name: 'basiccomponent',
   components: {
      ddoAlert,
      ddoWaiting,
   },

   data: () => {
      return {
         _this: null,
         loading: false,
         message: null,

         useVuex: false,
         theme: 'bootstrap4',
         template: 'default',
      }
   },

   created() {
   },

   mounted() {
   },

   methods: {
      refresh_loading(value) {
         this.loading = value;
      },

   },

}
</script>